import { Empresa } from "@/types/Empresa";
import axios, { AxiosPromise } from "axios";

export const getById = (codigo: string): AxiosPromise<Empresa> => 
    axios.get(`/api/empresa/${codigo}`);    

export const create = (values: Empresa): AxiosPromise<Empresa> => 
    axios.post(`/api/empresa`, values);    
export const update = (values: Empresa, id: string): AxiosPromise<Empresa> => 
    axios.put(`/api/empresa/${id}`, values);

// Marca da corretora atual; campos vazios = padrão Vigento
export type Marca = { nome: string; nomeMenu?: string; logo?: string; icone?: string;
    situacao?: string; diasTeste?: number; acessoCompleto: boolean };

export const marca = (): AxiosPromise<Marca> =>
    axios.get(`/api/empresa/marca`);
